// ------------------------------------------------------------------------
// -- JS ACCORDION
// ------------------------------------------------------------------------

var accordionBtn = document.querySelectorAll('.accordion__btn');
var accordionContent = document.querySelectorAll('.accordion__content');

for (var i = 0; i < accordionContent.length; i++) {
    accordionContent[i].classList.add('accordion__content--hidden');
}

for (var i = 0; i < accordionBtn.length; i++) {
    accordionBtn[i].addEventListener('click', accordion);
}

function accordion() {

    var btn = this
    var div = document.getElementById(this.getAttribute('aria-controls'));

    if (btn.getAttribute('aria-expanded') === 'true') {
        btn.setAttribute('aria-expanded', 'false');
        div.setAttribute('aria-hidden', 'true');
        div.classList.add('accordion__content--hidden');
    } else {
        btn.setAttribute('aria-expanded', 'true');
        div.setAttribute('aria-hidden', 'false');
        div.classList.remove('accordion__content--hidden');
    }

}